import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { connect } from "dvajs";
import { Modal, Button, Select, message } from "antd";
import { debounce } from "lodash";
import { cascadeSearchDept } from "@/api/search";
import "./index.less";

const { Option } = Select;
let inputDeptName = "";

function SearchDeptModal({
  visible,
  title,
  placeholder,
  currentUnitId,
  searchDeptType,
  getCurDeptInfo,
  onCancel
}: {
  visible: boolean;
  title: string;
  placeholder: string;
  currentUnitId: string;
  searchDeptType: string;
  getCurDeptInfo: (info: any) => void;
  onCancel: () => void;
}) {
  const [keyword, setKeyword] = useState(undefined);
  const [selDeptId, setSelDeptId] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [curDeptInfo, setCurDeptInfo] = useState<any>({});
  const [deptPageNo, setDeptPageNo] = useState(1);
  const [moretag, setMoreTag] = useState(false);

  const getDeptList = async (params: any) => {
    const { pageNo, keyword, tag } = params;
    const _param: any = {
      keyword,
      pageNo,
      pageSize: 20
    };
    if (currentUnitId) {
      _param.unitDeptId = currentUnitId;
      _param.includeUnitDept = true;
    }
    const result: any = await cascadeSearchDept(_param);
    if (result?.deptList && result?.deptList.length) {
      let _list: any = [];
      result.deptList.forEach((item: any) => {
        _list.push({
          name: item.fullName,
          id: item.deptId,
          sName: item.deptName
        });
      });
      const _curList = tag ? searchData.concat(_list) : _list;
      setSearchData(_curList);
      setMoreTag(result.hasNext);
      setDeptPageNo(pageNo);
    } else {
      setSearchData([]);
      setMoreTag(false);
      setDeptPageNo(1);
    }
  };

  const resetDeptData = () => {
    inputDeptName = "";
    setKeyword(undefined);
    setSearchData([]);
    setMoreTag(false);
    setDeptPageNo(1);
  };

  const onSearchDepts = debounce(async (val) => {
    if (!val) {
      inputDeptName = "";
      setKeyword(undefined);
      return;
    }
    inputDeptName = val;
    setKeyword(val);
    getDeptList({
      pageNo: 1,
      keyword: val
    });
  }, 500);

  const selDeptInfo = (params: any) => {
    const { _keyWord, key } = params;
    const obj: any = searchData.find((v: any) => v.id === key);
    setKeyword(_keyWord);
    // setSelDeptId(key);
    setCurDeptInfo({
      deptId: key,
      deptName: obj.sName,
      curType: searchDeptType
    });
  };

  const onOk = () => {
    if (curDeptInfo.deptId) {
      getCurDeptInfo({
        ...curDeptInfo
      });
    }
    onCancel();
  };

  return (
    <Modal
      visible={visible}
      destroyOnClose
      title={title}
      width={600}
      onCancel={onCancel}
      onOk={onOk}
      footer={
        <>
          <Button style={{ marginRight: 8 }} onClick={onCancel}>
            取消
          </Button>
          <Button type="primary" onClick={onOk}>
            确定
          </Button>
        </>
      }
      wrapClassName="search-dept-wrap"
    >
      <div>
        <Select
          showSearch
          allowClear
          onChange={(key) => {
            if (!key) {
              resetDeptData();
            }
          }}
          value={keyword}
          placeholder={placeholder}
          style={{
            width: "100%"
          }}
          filterOption={false}
          onSearch={onSearchDepts}
          onSelect={(value, option) => {
            // if (value === "more") {
            //   getDeptList({
            //     pageNo: deptPageNo + 1,
            //     keyword: inputDeptName,
            //     tag: "more"
            //   });
            // } else {
            //   selDeptInfo({ _keyWord: value, key: option.key });
            // }
            selDeptInfo({ _keyWord: value, key: option.key });
          }}
          dropdownRender={(menu) => (
            <>
              {menu}
              {moretag ? (
                <div
                  style={{
                    padding: "5px 12px",
                    cursor: "pointer"
                  }}
                  onClick={() => {
                    getDeptList({
                      pageNo: deptPageNo + 1,
                      keyword: inputDeptName,
                      tag: "more"
                    });
                  }}
                >
                  加载更多......
                </div>
              ) : null}
            </>
          )}
        >
          {searchData.map((item: any) => {
            return (
              <Option key={item.id} value={item.name}>
                {item.name}
              </Option>
            );
          })}
          {/* {moretag ? (
            <Option key="more" value="more">
              加载更多......
            </Option>
          ) : null} */}
        </Select>
      </div>
    </Modal>
  );
}

function mapStateToProps() {
  return {};
}

function mapDispatchToProps() {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchDeptModal);
